import { render, staticRenderFns } from "./Send-Review.vue?vue&type=template&id=0dd7a4c6"
import script from "./Send-Review.vue?vue&type=script&lang=js"
export * from "./Send-Review.vue?vue&type=script&lang=js"
import style0 from "./Send-Review.vue?vue&type=style&index=0&id=0dd7a4c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports